


































































































































































































































































































import InterventionsListFilters from "./InterventionsListPartials/InterventionsListFilters.vue";
import InterventionRow from "./InterventionsListPartials/InterventionRow.vue";
import InterventionModal from "./InterventionModal.vue";
import InterventionReassignEmployeModal from "./InterventionReassignEmployeModal.vue";
import { InterventionApi } from "../api/InterventionApi";
import Pagination from "../core/UI/Pagination.vue";
import { Intervention } from "../models/Intervention";
import Dropdown from "../core/UI/Dropdown.vue";
import BonDePassageModal from "./BonDePassageModal.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import EntryMailsModal from "../journal/EntryMailsModal.vue";
import InterventionReassignDateModal from "./InterventionReassignDateModal.vue";
import InterventionControlModal from "./InterventionControlModal.vue";
import InterventionSetupModal from "./InterventionSetupModal.vue";
import PerPage from "../core/UI/PerPage.vue";
import ExportButton from "../core/UI/ExportButton.vue";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";

export default {
    name: "InterventionsList",
    components: {
        PerPage,
        ExportButton,
        InterventionControlModal,
        InterventionSetupModal,
        InterventionReassignDateModal,
        EntryMailsModal,
        AutoRefresh,
        BonDePassageModal,
        Dropdown,
        InterventionRow,
        InterventionModal,
        InterventionReassignEmployeModal,
        InterventionsListFilters,
        Pagination,
    },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            interventions: [],
            totalDurees: { total_duree_prevue: 0, total_duree_reelle: 0 },
            selectedInterventions: [],
            filters: {},
            sort: "",
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            InterventionApi: new InterventionApi(),
            interventionModal: {
                isNew: false,
                interventionId: null,
                forceEditing: false,
            },
            notificationModal: {
                show: false,
                mails: [],
            },
            showReassignEmployeModal: false,
            showReassignDateModal: false,
            showControlModal: false,
            showSetupModal: false,
            showBonDePassageModal: false,
            showAnomalies: false,
            loading: false,
            lastLoadingId: null,
        };
    },
    created() {
        // Pas de chargement ici : le composant de filtres émet ses filtres
        // par défaut (date du jour) à sa création, ce qui déclenche le
        // premier loadPage via le watcher. L'appel sans filtre de date qui
        // partait d'ici parcourait toute la table (9,6 s) pour être aussitôt
        // remplacé.
    },
    methods: {
        loadPage(page: number, hideLoading = false, useCache = true) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "photos,notifications,client.related_contacts",
                sort: this.sort,
                useCache: useCache,
                withPreloading: !hideLoading,
            };
            params = _.assign(params, self.filters);
            self.loading = !hideLoading;
            let loadingId = _.uniqueId("loading_");
            self.lastLoadingId = loadingId;

            self.totalDurees.total_duree_prevue = 0;
            self.totalDurees.total_duree_reelle = 0;

            return self.InterventionApi.getAll(params)
                .then(function (response) {
                    if (loadingId !== self.lastLoadingId) return;

                    let { data, metadata, paginator } = response;
                    self.interventions = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    self.metadata = metadata;

                    self.InterventionApi.getTotalDurees(params).then(function (
                        response
                    ) {
                        self.totalDurees.total_duree_prevue =
                            response.total_duree_prevue;
                        self.totalDurees.total_duree_reelle =
                            response.total_duree_reelle;
                    });

                    return self.interventions;
                })
                .catch(function (error) {
                    self.interventions = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        refreshInterventions(useCache = true) {
            if (!this.loading) {
                this.loadPage(this.currentPage, true, useCache);
            }
        },
        //
        updateFilters(filters): void {
            this.filters = filters;
        },
        updateSort(sort): void {
            this.sort = sort;
        },
        //
        onInterventionSelect(intervention: Intervention, selected: boolean) {
            if (selected) {
                this.selectedInterventions.push(intervention);
            } else {
                _.remove(this.selectedInterventions, { id: intervention.id });
                this.$forceUpdate();
            }
        },
        selectedInterventionsCount(): number {
            return this.selectedInterventions.length;
        },
        //
        archiveSelectedInterventions() {
            let self = this;
            let title = "Voulez vous archiver ";
            if (self.selectedInterventionsCount() > 1) {
                title +=
                    "ces " +
                    self.selectedInterventionsCount() +
                    " interventions ?";
            } else {
                title += "cette intervention ?";
            }
            swal({
                title: title,
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(function () {
                let promises = [];
                _.each(
                    self.selectedInterventions,
                    function (intervention: Intervention) {
                        intervention.etat = Intervention.EEtat.Archived;
                        promises.push(self.InterventionApi.save(intervention));
                    }
                );
                Promise.all(promises).then(function () {
                    self.refreshInterventions(false);
                    self.resetSelectedInterventions();
                    swal(
                        "Les interventions ont bien été archivées !",
                        "",
                        "success"
                    );
                });
            });
        },
        //
        openReassignEmployeModal() {
            this.showReassignEmployeModal = true;
        },
        onReassignModalClose() {
            this.showReassignEmployeModal = false;
            this.refreshInterventions(false);
            this.resetSelectedInterventions();
        },
        //
        openReassignDateModal() {
            this.showReassignDateModal = true;
        },
        onReassignDateModalClose() {
            this.showReassignDateModal = false;
            this.refreshInterventions(false);
            this.resetSelectedInterventions();
        },
        //
        openControlModal() {
            this.showControlModal = true;
        },
        onControlModalClose() {
            this.showControlModal = false;
            this.refreshInterventions(false);
            this.resetSelectedInterventions();
        },
        //
        openSetupModal() {
            this.showSetupModal = true;
        },
        onSetupModalClose() {
            this.showSetupModal = false;
            this.refreshInterventions(false);
            this.resetSelectedInterventions();
        },
        //
        openBonDePassageModal() {
            let selectedInterventionsClientsId = _.chain(
                this.selectedInterventions
            )
                .map("client_id")
                .uniq()
                .value();
            if (selectedInterventionsClientsId.length > 1) {
                swal(
                    "Attention",
                    "Vous ne pouvez pas sélectionner des interventions concernant des clients différents.",
                    "warning"
                );
            } else {
                this.showBonDePassageModal = true;
            }
        },
        onBonDePassageModalClose() {
            this.showBonDePassageModal = false;
            this.refreshInterventions(false);
            this.resetSelectedInterventions();
        },
        //
        openNotificationModal(intervention: Intervention) {
            if (intervention.notifications.length > 0) {
                this.notificationModal.mails = intervention.displayableMails;
                this.notificationModal.show = true;
            }
        },
        onNotificationModalClose() {
            this.notificationModal.show = false;
            this.notificationModal.mails = [];
        },
        //
        resetSelectedInterventions() {
            this.selectedInterventions = [];
        },
        //
        toggleAnomalies() {
            this.showAnomalies = !this.showAnomalies;
        },
        // Actions
        showIntervention(intervention: Intervention) {
            this.interventionModal.isNew = false;
            this.interventionModal.forceEditing = false;
            this.interventionModal.interventionId = intervention.id;
        },
        editIntervention(intervention: Intervention) {
            this.interventionModal.isNew = false;
            this.interventionModal.forceEditing = true;
            this.interventionModal.interventionId = intervention.id;
        },
        createIntervention() {
            this.interventionModal.interventionId = null;
            this.interventionModal.forceEditing = true;
            this.interventionModal.isNew = true;
        },
        onInterventionModalClose(): void {
            this.interventionModal.interventionId = null;
            this.interventionModal.forceEditing = false;
            this.interventionModal.isNew = false;
            this.refreshInterventions(false);
        },
        deleteIntervention(intervention: Intervention): void {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cette intervention&nbsp;?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.InterventionApi.delete(intervention.id, raison)
                    .then(function () {
                        self.refreshInterventions(false);
                        swal(
                            "L'intervention a bien été supprimée !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        exportToPdf() {
            // Onglet ouvert pendant le clic (sinon bloqué comme popup), puis
            // dirigé vers l'URL signée : il n'envoie pas le JWT (AW-45).
            let onglet = window.open("", "_blank");

            this.InterventionApi.getInterventionsPdfSignedUrl(
                this.getExportParams()
            )
                .then(function (url) {
                    if (onglet) {
                        onglet.location.href = url;
                    }
                })
                .catch(function () {
                    if (onglet) {
                        onglet.close();
                    }
                    swal("L'export PDF a échoué", "", "error");
                });
        },
        getExportParams() {
            let params = {};

            for (const [key, value] of Object.entries(this.filters)) {
                if (value !== null && value !== undefined && value !== "") {
                    params[key] = value.toString();
                }
            }

            if (this.sort) {
                params["sort"] = this.sort;
            }

            return params;
        },

        doAction(
            action: Intervention.UIActionType,
            intervention: Intervention
        ): void {
            if (action === Intervention.UIActionType.show_intervention) {
                this.showIntervention(intervention);
            } else if (action === Intervention.UIActionType.edit_intervention) {
                this.editIntervention(intervention);
            } else if (
                action === Intervention.UIActionType.delete_intervention
            ) {
                this.deleteIntervention(intervention);
            } else if (
                action === Intervention.UIActionType.create_intervention
            ) {
                this.createIntervention();
            } else if (action === Intervention.UIActionType.show_notification) {
                this.openNotificationModal(intervention);
            }
        },
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
        itemsPerPage: function () {
            this.loadPage(1);
        },
    },
};
